import React from 'react'
import { Field } from 'formik'
import { Heading } from 'react-bulma-components'
import { formatDuration } from '../../../../utils/date'
import DescriptionList from '../../../description-list/description-list'
import InputField from '../../../form/fields/input'
import { isAuthorizedFor } from '../../../protected/protected'
import { WorkPeriodManualBreakProps } from './types'

/**
 * Composant pour gérer les pauses manuelles d'une période de travail
 * Affiche les informations sur les pauses théoriques, pointées et permet la correction
 */
const WorkPeriodManualBreak: React.FC<WorkPeriodManualBreakProps> = ({ workPeriod }) => {
  const { breakAllowedAfter } = workPeriod.clockingRules.break

  const inputFieldDisabled =
    !workPeriod.__actions.canBeManualClocked ||
    !isAuthorizedFor(['employerMember'], {
      resource: 'missions',
      name: 'updateWorkPeriodManualBreak',
    })

  return (
    <DescriptionList
      labelColumnWidth={'30%'}
      items={[
        {
          label: <Heading size={4}>Pause</Heading>,
          value: ' ',
        },
        {
          label: 'Théorique',
          value: `${formatDuration(workPeriod.summary.durations.theoreticalBreaks)}`,
        },
        {
          label: 'Après',
          value: formatDuration(breakAllowedAfter * 60 * 1000),
        },
        ...(workPeriod.clockingRules.break.clocked
          ? [
              {
                label: 'Pointées',
                value: formatDuration(workPeriod.summary.durations.clockedBreaks),
              },
              {
                label: 'Comptabilisé',
                value: formatDuration(workPeriod.summary.durations.breaks),
              },
            ]
          : []),
        {
          label: 'Corrigé',
          value: (
            <Field
              type="number"
              min={0}
              max={60 * 24}
              step={1}
              name={`workPeriod.manualBreak`}
              component={InputField}
              dataTest="work-period-manual-break"
              disabled={inputFieldDisabled}
              help="Spécifier une valeur en minutes"
            />
          ),
        },
      ]}
    />
  )
}

export default WorkPeriodManualBreak
